import { PatronEditBooking } from "../../../types";

export const isGuestLikeClientType = (
  clientType: PatronEditBooking.RoundPlayer["clientType"]
) => {
  return (
    clientType === "guest" ||
    clientType === "unknownGuest" ||
    clientType === "newGuest" ||
    clientType === "unknownCustomer"
  );
};

export const isMemberLikeClientType = (
  clientType: PatronEditBooking.RoundPlayer["clientType"]
) => {
  return (
    clientType === "member" ||
    clientType === "memberHold" ||
    clientType === "customer"
  );
};

export const shouldClearRatesForPlayerSwap = (
  previousPlayer: PatronEditBooking.RoundPlayer,
  player: PatronEditBooking.RoundPlayer,
  isPrivate = false
) => {
  const wasMemberLike = isMemberLikeClientType(previousPlayer.clientType);
  const wasGuestLike = isGuestLikeClientType(previousPlayer.clientType);
  const isMemberLike = isMemberLikeClientType(player.clientType);
  const isGuestLike = isGuestLikeClientType(player.clientType);

  if ((wasMemberLike && isGuestLike) || (wasGuestLike && isMemberLike)) {
    return true;
  }

  if (
    isPrivate &&
    previousPlayer.clientType === "member" &&
    player.clientType === "member" &&
    previousPlayer.id !== player.id
  ) {
    return true;
  }

  if (
    isPrivate &&
    previousPlayer.clientType === "memberHold" &&
    player.clientType === "member"
  ) {
    return true;
  }

  return false;
};
